<template>
  <div class="card pa-4">
    <div class="d-flex justify-space-between">
      {{ title }}
      <v-icon size="24" class="icon" :icon="icon"></v-icon>
    </div>
    <div>
      <div class="text-light">
        {{ subtitle }}
      </div>
      <div>
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  font-size: 20px;
  border-radius: 20px;
  color: white;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.icon {
  color: white;
}
.text-light {
  margin-top: 10px;
  font-weight: 300;
  font-size: 12px;
}
</style>